const AMAZON_AWS_CODECOMMIT_HOST = "console.aws.amazon.com";
function readAwsCodeCommitIntegrationConfig(config) {
  const accessKeyId = config.getOptionalString("accessKeyId");
  const secretAccessKey = config.getOptionalString("secretAccessKey")?.trim();
  const roleArn = config.getOptionalString("roleArn");
  const externalId = config.getOptionalString("externalId");
  const region = config.getString("region");
  const host = config.getOptionalString("host") || `${region}.${AMAZON_AWS_CODECOMMIT_HOST}`;
  return {
    host,
    accessKeyId,
    secretAccessKey,
    roleArn,
    externalId,
    region
  };
}
function readAwsCodeCommitIntegrationConfigs(configs) {
  return configs.map(readAwsCodeCommitIntegrationConfig);
}

export { readAwsCodeCommitIntegrationConfig, readAwsCodeCommitIntegrationConfigs };
//# sourceMappingURL=config.esm.js.map
